export default "__VITE_ASSET__6ffa6fa6__"